import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Education.scss';

interface EducationItem {
  school: string;
  degree: string;
  period: string;
  description?: string;
}

// TODO: replace with real data
const educationData: EducationItem[] = [
  {
    school: "SMA Negeri 1 Purwareja Klampok",
    degree: "Merdeka Curriculum",
    period: "2023 - 2026",
    description: "",
  },
];

function Education() {
  return (
    <div id="education">
      <div className="items-container">
        <h1>Education</h1>
        <div className="education-grid">
          {educationData.map((edu, index) => (
            <div className="education-item" key={`${edu.school}-${index}`}>
              <div className="education-icon">
                <FontAwesomeIcon icon={faGraduationCap} />
              </div>
              <span className="education-date">{edu.period}</span>
              <h3 className="education-title">{edu.school}</h3>
              <h4 className="education-subtitle">{edu.degree}</h4>
              {edu.description && <p>{edu.description}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Education;
